import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PAYROLL_LOANS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.CREATE_PAYROLL_LOAN:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_PAYROLL_LOAN:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.DELETE_PAYROLL_LOAN:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
